import { useSearchParams } from 'react-router-dom';

import { useCurrentUser } from '@qualio/ui-components';

import { useContext, useMemo } from 'react';
import { backendTaskApi } from '../../../../api/backendTask';
import { isDocumentAccount } from '../../../../api/model/document';
import { ExportDocumentListButton } from '../../Export/ExportDocumentListButton/ExportDocumentListButton';
import { FOR_TRAINING_STATUS } from '../types';
import { resolveActionFilters, resolveStatusFilters } from './constants';
import { useWorkspaceAccountFilter } from './hooks/useWorkspaceAccountFilter';
import { WorkspaceTabsContext } from './WorkspaceTabsContext';
import { WorkspaceTabs } from './WorkspaceV2';

export const ExportButtonWrapper = () => {
  const currentUser = useCurrentUser();
  const [searchParams] = useSearchParams();
  const tagsParams = searchParams.getAll('tags');
  const searchQuery = searchParams.get('query');
  const sortingValue = searchParams.get('orderBy');
  const templatesParam = searchParams.getAll('types');
  const ownerParam = searchParams.get('owner');
  const actionParam = searchParams.get('action');
  const statusParam = searchParams.get('status');
  const accountParam = searchParams.get('account');
  const { currentTab, isReadyForExport } = useContext(WorkspaceTabsContext);
  const isYourActions = currentTab === WorkspaceTabs.YOUR_ACTIONS;

  const { accountFilterApplies } = useWorkspaceAccountFilter(currentTab);
  const accountFilter =
    accountFilterApplies && accountParam && isDocumentAccount(accountParam)
      ? accountParam
      : undefined;

  const currentStatusFilters = useMemo(
    () =>
      isYourActions
        ? resolveActionFilters(actionParam)
        : resolveStatusFilters(statusParam),
    [isYourActions, actionParam, statusParam],
  );

  const exportTaskMethod = useMemo(() => {
    if (isYourActions && currentStatusFilters.includes(FOR_TRAINING_STATUS)) {
      return backendTaskApi.startUserTrainingDocumentsExportTask;
    }
    switch (currentTab) {
      case WorkspaceTabs.YOUR_DOCUMENTS:
        return backendTaskApi.startUserDocumentsExportTask;
      case WorkspaceTabs.YOUR_ACTIONS:
        return backendTaskApi.startUserActionableDocumentsExportTask;
      case WorkspaceTabs.ALL_DOCUMENTS:
        return backendTaskApi.startAllDocumentsExportTask;
    }
  }, [currentTab, isYourActions, currentStatusFilters]);

  return (
    <ExportDocumentListButton
      currentUser={currentUser}
      tagsFilter={tagsParams}
      isDisabled={!isReadyForExport}
      searchQuery={searchQuery}
      exportTaskMethod={exportTaskMethod}
      statusFilters={currentStatusFilters}
      sortingValue={sortingValue}
      templatesFilter={templatesParam}
      ownerFilter={ownerParam ? Number(ownerParam) : null}
      accountFilter={accountFilter}
    />
  );
};
